import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { useCanQueryPii } from '../../fields/useCanQueryPii';
import { filterableFields, opsFor, valueKindOf, withField } from './advancedFilter';
import type { AdvancedOp } from './AdvancedOp';
import { AdvancedValue } from './AdvancedValue';
import type { IAdvancedRowProps } from './IAdvancedRowProps';

/**
 * Рядок умови розширених фільтрів (прототип v4): сітка «Де/і · поле · умова · значення · ×» (48px, 140–260px, 120–200px, 140–320px, 32px);
 * поле — усі поля типу, крім довгого тексту (поля з персональними даними — лише для Owner/Admin); умови — дозволені API для типу поля;
 * зміна поля скидає значення.
 */
export function AdvancedRow({ ws, rt, condition, index, onChange, onRemove }: IAdvancedRowProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const fields = filterableFields(rt, useCanQueryPii(ws));
  const field = fields.find((f) => f.key === condition.field);
  return (
    <div className="lv-adv__row">
      <span className="lv-adv__n">{index === 0 ? t('listbar.where') : t('listbar.and')}</span>
      <select className="lv-select" value={condition.field} aria-label={t('listbar.field')} onChange={(e) => onChange(withField(condition, fields.find((f) => f.key === e.target.value)))}>
        {fields.map((f) => <option key={f.key} value={f.key}>{strings.field(rt.key, f.key, f.label)}</option>)}
      </select>
      <select className="lv-select" value={condition.op} aria-label={t('listbar.condition')} onChange={(e) => onChange({ ...condition, op: e.target.value as AdvancedOp })}>
        {opsFor(field).map((op) => <option key={op} value={op}>{t(`listbar.ops.${op}`)}</option>)}
      </select>
      <AdvancedValue ws={ws} rt={rt} field={field} kind={valueKindOf(field, condition.op)} value={condition.value} onChange={(value) => onChange({ ...condition, value })} />
      <button type="button" className="lv-adv__remove" aria-label={t('listbar.removeCondition')} title={t('listbar.removeCondition')} onClick={onRemove}>×</button>
    </div>
  );
}
